import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-layout-row',
  templateUrl: './layout-row.component.html',
  styleUrls: ['./layout-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle]
})
export class LayoutRowComponent {
  margin = input<string>('1rem');
}
